import { useT } from '@/i18n';

const FACEBOOK_URL = 'https://facebook.com/96digitallabs';
const WHATSAPP_URL = 'https://wa.me/4915231480096';

function CreditLink({ href, children }: { href: string; children: string }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="external">
      {children}
    </a>
  );
}

export function CompanyCredit() {
  const t = useT();
  return (
    <p className="company-credit">
      {t.companyCredit} <CreditLink href={FACEBOOK_URL}>Facebook</CreditLink> {t.companyCreditAnd}{' '}
      <CreditLink href={WHATSAPP_URL}>WhatsApp</CreditLink>.
    </p>
  );
}
